import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CPPCOIRequestItemsFilter } from '../../../models/CPPCOIRequest/CPPCOIRequestItemsFilter';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from './../../../services/common/common.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { MasterConstants } from './../../../common/constants/master-constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cpp-coi-request-filter',
  templateUrl: './cpp-coi-request-filter.component.html',
  styleUrls: ['./cpp-coi-request-filter.component.scss']
})

export class CppCoiRequestFilterComponent implements OnDestroy {
  private subscription = new Array<Subscription>();
  selectedFilter: string;
  filterValueList: any[] = [];
  filterList: any[];
  searchButtonClick = false;
  filter: CPPCOIRequestItemsFilter = new CPPCOIRequestItemsFilter();
  productFilters: any;
  searchValue = '';
  invoicedProductList: any = [];
  disableFilterBtn = true;
  isPaste = false;
  public partialSearchValue = '';
  productLineMasterList: any = [];

  @Input()
  set filters(val: any[]) {
    this.filterList = val;
    if (val[0]) { this.selectedFilter = val[0].column; }
  }
  get filters(): any[] {
    return this.filterList;
  }

  @Output()
  SearchFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  ClearFilter: EventEmitter<any> = new EventEmitter<any>();

  constructor(public commonService: CommonService,
    public toastrService: ToastrService,
    private localStorageService: LocalStorageService,
  ) {
    this.resetFilterInputValue();

    if (this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.CPP_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_CPP_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_CPP_LIST));
    }

    this.searchButtonClick = false;
  }
  public selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productName = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.productName);
      this.retainFilter(this.productFilters.productName, 'ProductName');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }

  public selectPackageSize($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.packageSize = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.packageSize = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.packageSize = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.packageSize);
      this.retainFilter(this.productFilters.packageSize, 'PackageSize');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }

  public selectVendortName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.vendorName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.vendorName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.vendorName = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.vendorName);
      this.retainFilter(this.productFilters.vendorName, 'VendorName');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }

  public selectProductLine($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productLine = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productLine = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productLine = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.productLine);
      this.retainFilter(this.productFilters.ProductLine, 'ProductLine');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }

  onPaste(event: ClipboardEvent) {
    if (event) {
      const clipboardData = event.clipboardData;
      const selectedValue = clipboardData.getData('text');
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        this.disableFilterBtn = false;
        this.isPaste = true;
      }
    }
    else {
      this.resetFilterInputValue();
    }
  }

  validateProductSearch(toValidateInput: any) {
    // To Validate Brand
    if ((toValidateInput !== null && toValidateInput !== '' && toValidateInput.toString().trim().length >= 2)
      || this.productFilters.itemNo !== null && this.productFilters.itemNo !== '' && this.productFilters.itemNo.toString().trim().length >= 2
      || this.productFilters.productName !== null && this.productFilters.productName !== '' && this.productFilters.productName.toString().trim().length >= 2
      || this.productFilters.packageSize !== null && this.productFilters.packageSize !== '' && this.productFilters.packageSize.toString().trim().length >= 2
      || this.productFilters.vendorName !== null && this.productFilters.vendorName !== '' && this.productFilters.vendorName.toString().trim().length >= 2
      || this.productFilters.productLine !== null && this.productFilters.productLine !== '' && this.productFilters.productLine.toString().trim().length >= 2
    ) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = this.isPaste ? false : true;
      this.isPaste = false;
    }
  }
  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.filterValueList) {
      const selectedIds = '';

      switch (type) {
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'ProductName':
          this.filter.productName = selectedIds;
          break;
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
          break;
        case 'VendorName':
          this.filter.vendorName = selectedIds;
          break;
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        // Set Item No
        if (this.productFilters.itemNo && this.productFilters.itemNo.length > 0) {
          let strINO = '';
          this.productFilters.itemNo.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strINO.substr(0, strINO.length - 2));
          this.filter.itemNo = strINO.substr(0, strINO.length - 2);
        }

        // Set Product Name
        if (this.productFilters.productName && this.productFilters.productName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.productName);
          this.filter.productName = this.productFilters.productName;
        }

        // Set Package Size
        if (this.productFilters.packageSize && this.productFilters.packageSize != '') {
          this.filterValueList.push('Package Size : ' + this.productFilters.packageSize);
          this.filter.packageSize = this.productFilters.packageSize;
        }

        // Set Vendor Name
        if (this.productFilters.vendorName && this.productFilters.vendorName != '') {
          this.filterValueList.push('Vendor Name : ' + this.productFilters.vendorName);
          this.filter.vendorName = this.productFilters.vendorName;
        }

        // Set Product Line
        if (this.productFilters.productLine && this.productFilters.productLine.length > 0) {
          let strPL = '';
          let strPLValue = '';
          this.productFilters.productLine.forEach(x => {
            strPL = strPL + x + ', ';
            const productLine = this.productLineMasterList.find(y => y.value == x);
            if (productLine != undefined) {
              strPLValue = strPLValue + productLine.value + ', ';
            }
          });
          this.filterValueList.push('Product Line : ' + strPLValue.substr(0, strPLValue.length - 2));
          this.filter.productLine = this.productFilters.productLine;
          this.filter.productLine = strPL.substr(0, strPL.length - 2);
        }
        else {
          this.filter.productLine = null;
        }
      }
    }
    this.enableDisableSearchButton();
    this.searchValue = '';
    this.partialSearchValue = '';

    if (this.filterValueList.length < 1) {
      this.ClearFilter.emit(this.filter);
    }
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }
  // Remove all chip filters
  removeAllFilter() {
    if (this.filterValueList.length > 0) {
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.enableDisableSearchButton();
      this.filter.clearAll = true;
      this.SearchFilter.emit(this.filter);
      // this.onClearFilter.emit(this.filter);
    }
  }
  // Clear a selected filter value
  clearFilter(filterValue) {
    const index = filterValue ? this.filterValueList.indexOf(filterValue) : -1;
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      this.removeFilter(filterValue);
      this.enableDisableSearchButton();

      if (this.filterValueList.length < 1) {
        this.ClearFilter.emit(this.filter);
      }
    }
  }

  // Search button event
  onFilter() {
    this.retainFilter(null, ' ');
    this.SearchFilter.emit(this.filter);
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand(Product)
    if (productFilter.productName !== null && productFilter.productName !== '') {
      isValid = true;
    }

    // // To Validate PackageSize
    if (productFilter.packageSize != null && productFilter.packageSize !== '') {
      isValid = true;
    }

    // To Validate itemNo
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate VendorName
    if (productFilter.vendorName !== null && productFilter.vendorName !== '') {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.productLine !== null && productFilter.productLine !== '') {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.packageSize == null || productFilter.packageSize.length <= 0)
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && productFilter.vendorName == null
      && productFilter.productLine == null
    ) {
      isValid = false;
    }
    return isValid;
  }

  // Enable Disable Search
  enableDisableSearchButton() {
    if (this.validateFilter(this.productFilters)) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }
  }

  // Remove a selected chip search filter
  removeFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.itemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Product Name':
        this.productFilters.productName = null;
        this.filter.productName = null;
        break;
      case 'Package Size':
        this.productFilters.packageSize = null;
        this.filter.packageSize = null;
        break;
      case 'Vendor Name':
        this.productFilters.vendorName = null;
        this.filter.vendorName = null;
        break;
      case 'Product Line':
        this.productFilters.productLine = null;
        this.filter.productLine = null;
        break;
      default:
        break;
    }
  }

  // Re initialise the Filters
  resetFilterInputValue() {
    this.productFilters = {
      'itemNo': [],
      'productName': null,
      'packageSize': [],
      'vendorName': null,
      'productLine': null
    };

    this.filter = {
      'itemNo': null,
      'clearAll': false,
      'productName': null,
      'packageSize': null,
      'vendorName': null,
      'productLine': null
    };
  }
  // Page destroy event
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
